import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, NamedLink } from '../../components';
import css from './ListingPage.module.css';
import { buildRundownText } from '../../util/listingSpecs';

/**
 * "The Rundown" — auto-generated, unique, crawlable SEO paragraph.
 *
 * WHY: ~63% of listings have thin owner descriptions (<160 chars). This ADDS a
 * second block of unique, keyword-rich, geo-targeted prose built entirely from
 * structured data we already own (year/make/model, dimensions, weight, hitch,
 * trailer type, city/state, price). It NEVER rewrites the owner's description.
 *
 * SEO discipline:
 *   - SSR-ONLY: this is a plain <p> rendered server-side, so Googlebot reads it
 *     in the DOM. Nothing here is lazy-loaded or client-gated.
 *   - Anti-spun-content: sentence STRUCTURE varies per listing (deterministic
 *     template pick inside buildRundownText), and every clause degrades
 *     gracefully — we only assert facts we have, never fabricate.
 *   - Internal linking: the state name links to its state hub (/states/...),
 *     passing link equity + reinforcing local relevance. Cities are NOT linked
 *     (their hub slugs are CMS-arbitrary and a missing one soft-404s).
 *
 * Renders nothing when there isn't enough structured data to say something
 * unique (buildRundownText returns null).
 */
const SectionRundownMaybe = props => {
  const { publicData, title, priceText, priceUnit, listingId } = props;

  if (!publicData) return null;

  const rundown = buildRundownText({
    publicData,
    title,
    priceText,
    priceUnit,
    listingId,
  });

  if (!rundown || !rundown.segments || rundown.segments.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionRundown}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ListingPage.rundownTitle" defaultMessage="The Rundown" />
      </Heading>
      <p className={css.rundownText}>
        {rundown.segments.map((seg, i) => {
          if (typeof seg === 'string') {
            return <React.Fragment key={i}>{seg}</React.Fragment>;
          }
          // Link token: { stateName, stateSlug } -> state hub NamedLink.
          if (seg && seg.stateSlug && seg.stateName) {
            return (
              <NamedLink
                key={i}
                name="StateListsPage"
                params={{ state: seg.stateSlug }}
                className={css.rundownLink}
              >
                {seg.stateName}
              </NamedLink>
            );
          }
          return null;
        })}
      </p>
    </section>
  );
};

export default SectionRundownMaybe;
